export default __webpack_public_path__ + "static/media/discover.75880ec7.png";